import React, { Component } from 'react';

import { Loader } from 'components/loader';

import ConfigSparkle from './ConfigSparkle';

import ConfigService from '../ConfigService';

export default class ConfigSparkleManager extends Component {
  state = {
    active: false,
    loading: true
  };

  componentDidMount() {
    this.setUp();
  }

  async setUp() {
    const { active } = await ConfigService.getCommunicationStatus();

    this.setState({ active, loading: false });
  }

  save = async () => {
    const { active } = this.state;

    try {
      await ConfigService.updateSparkleData(active);
    } catch {
      this.setState({ active: !active });
    }
  };

  sparkleToggleChangeHandler = async () => {
    const { active } = this.state;

    this.setState({ active: !active }, this.save);
  };

  render() {
    const { active, loading } = this.state;

    return (
      <>
        {loading && <Loader fixed />}
        <ConfigSparkle
          active={active}
          onToggleChange={this.sparkleToggleChangeHandler}
        />
      </>
    );
  }
}
